import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn, ia } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const MobileCell = ({ col, row, idx }) => {
  let value = row?.[col?.field];
  if (col.valueFormatter)
    value = col.valueFormatter({ value, data: row, rowIdx: idx, colDef: col });
  if (col.cellRenderer) value = col.cellRenderer({ value, data: row, rowIdx: idx, colDef: col });

  return (
    <div className="flex justify-between gap-2">
      <Typography variant="p" size="xs" weight="medium" color="neutral-700">
        {col.headerName}
      </Typography>
      <Typography variant="p" size="xs" color="neutral-700">
        {value}
      </Typography>
    </div>
  );
};

const TableRowMobile = ({
  columnDefs,
  row,
  idx,
  isExpanded,
  handleExpand,
  className,
  CustomRowHeader
}) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (!isMobile) return null;

  const firstCell = CustomRowHeader ? null : columnDefs[0];
  const restColumns = CustomRowHeader ? columnDefs : columnDefs.slice(1);

  return (
    <tr key={idx} className={cn('flex flex-col gap-2 px-2 py-3', className)}>
      {!CustomRowHeader && (
        <div className="flex items-center gap-2">
          {ia(row.children) && (
            <Button
              variant="link"
              size="small"
              icon="chevron-up-linear"
              iconSize={16}
              iconColor="neutral"
              className={cn(
                'w-fit transition-transform duration-200',
                isExpanded && 'rotate-180',
                !row.is_detailed && 'hidden'
              )}
              onClick={handleExpand}
            />
          )}
          <div className="flex flex-col gap-1 pb-2">
            {firstCell
              ? firstCell.cellRenderer
                ? firstCell.cellRenderer({
                    value: row[firstCell.field],
                    data: row,
                    rowIdx: idx,
                    colDef: firstCell
                  })
                : row[firstCell.field]
              : null}
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-x-6 gap-y-1">
        {restColumns.map((col) => (
          <MobileCell key={col.field} col={col} row={row} idx={idx} />
        ))}
      </div>
    </tr>
  );
};

export default TableRowMobile;
